// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Auth Container */
.auth-container {
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #ffffff;
  padding: 20px;
}

.auth-box {
  background: white;
  border-radius: 8px;
  border: 1px solid #e5e5e5;
  padding: 40px;
  width: 100%;
  max-width: 450px;
}

.auth-header {
  text-align: center;
  margin-bottom: 30px;
}

.auth-header h1 {
  font-size: 2.5rem;
  font-weight: 400;
  color: #1a1a1a;
  margin: 0 0 8px 0;
  letter-spacing: -0.5px;
}

.auth-header p {
  font-size: 1rem;
  color: #666;
  margin: 0;
}

/* Form Styles */
.auth-form h2 {
  font-size: 1.2rem;
  font-weight: 500;
  color: #1a1a1a;
  margin: 0 0 24px 0;
  text-align: center;
}

.form-group {
  margin-bottom: 20px;
}

.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}

.form-group label {
  display: block;
  font-size: 0.9rem;
  font-weight: 500;
  color: #1a1a1a;
  margin-bottom: 8px;
}

.form-group input {
  width: 100%;
  padding: 12px 16px;
  font-size: 1rem;
  border: 2px solid #d0d0d0;
  border-radius: 6px;
  transition: border-color 0.2s;
  box-sizing: border-box;
  background: #fafafa;
}

.form-group input:focus {
  outline: none;
  border-color: #1a1a1a;
  background: #ffffff;
}

.form-group input::placeholder {
  color: #999;
}

/* Buttons */
.btn-primary {
  width: 100%;
  padding: 12px 24px;
  background: #1a1a1a;
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s ease;
  margin-top: 8px;
}

.btn-primary:hover:not(:disabled) {
  background: #333;
}

.btn-primary:disabled {
  background: #ccc;
  cursor: not-allowed;
}

/* Auth Links */
.auth-links {
  margin-top: 24px;
  text-align: center;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.auth-links a {
  color: #1a1a1a;
  text-decoration: none;
  font-size: 0.9rem;
  transition: color 0.2s;
}

.auth-links a:hover {
  text-decoration: underline;
}

/* Error Messages */
.error-message {
  background: #fef2f2;
  border: 1px solid #fecaca;
  color: #dc2626;
  padding: 12px;
  border-radius: 6px;
  margin-bottom: 20px;
  font-size: 0.9rem;
}

/* Success Messages */
.success-message {
  background: #f0fdf4;
  border: 1px solid #bbf7d0;
  color: #16a34a;
  padding: 12px;
  border-radius: 6px;
  margin-bottom: 20px;
  font-size: 0.9rem;
}

/* Responsive */
@media (max-width: 768px) {
  .auth-box {
    padding: 30px 24px;
  }

  .form-row {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/Auth.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB;EACE,iBAAiB;EACjB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,SAAS;AACX;;AAEA,gBAAgB;AAChB;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,6BAA6B;EAC7B,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA,YAAY;AACZ;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,sCAAsC;EACtC,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,mBAAmB;AACnB;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA,qBAAqB;AACrB;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA,eAAe;AACf;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,0BAA0B;EAC5B;AACF","sourcesContent":["/* Auth Container */\n.auth-container {\n  min-height: 100vh;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background: #ffffff;\n  padding: 20px;\n}\n\n.auth-box {\n  background: white;\n  border-radius: 8px;\n  border: 1px solid #e5e5e5;\n  padding: 40px;\n  width: 100%;\n  max-width: 450px;\n}\n\n.auth-header {\n  text-align: center;\n  margin-bottom: 30px;\n}\n\n.auth-header h1 {\n  font-size: 2.5rem;\n  font-weight: 400;\n  color: #1a1a1a;\n  margin: 0 0 8px 0;\n  letter-spacing: -0.5px;\n}\n\n.auth-header p {\n  font-size: 1rem;\n  color: #666;\n  margin: 0;\n}\n\n/* Form Styles */\n.auth-form h2 {\n  font-size: 1.2rem;\n  font-weight: 500;\n  color: #1a1a1a;\n  margin: 0 0 24px 0;\n  text-align: center;\n}\n\n.form-group {\n  margin-bottom: 20px;\n}\n\n.form-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 16px;\n}\n\n.form-group label {\n  display: block;\n  font-size: 0.9rem;\n  font-weight: 500;\n  color: #1a1a1a;\n  margin-bottom: 8px;\n}\n\n.form-group input {\n  width: 100%;\n  padding: 12px 16px;\n  font-size: 1rem;\n  border: 2px solid #d0d0d0;\n  border-radius: 6px;\n  transition: border-color 0.2s;\n  box-sizing: border-box;\n  background: #fafafa;\n}\n\n.form-group input:focus {\n  outline: none;\n  border-color: #1a1a1a;\n  background: #ffffff;\n}\n\n.form-group input::placeholder {\n  color: #999;\n}\n\n/* Buttons */\n.btn-primary {\n  width: 100%;\n  padding: 12px 24px;\n  background: #1a1a1a;\n  color: white;\n  border: none;\n  border-radius: 6px;\n  font-size: 1rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n  margin-top: 8px;\n}\n\n.btn-primary:hover:not(:disabled) {\n  background: #333;\n}\n\n.btn-primary:disabled {\n  background: #ccc;\n  cursor: not-allowed;\n}\n\n/* Auth Links */\n.auth-links {\n  margin-top: 24px;\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.auth-links a {\n  color: #1a1a1a;\n  text-decoration: none;\n  font-size: 0.9rem;\n  transition: color 0.2s;\n}\n\n.auth-links a:hover {\n  text-decoration: underline;\n}\n\n/* Error Messages */\n.error-message {\n  background: #fef2f2;\n  border: 1px solid #fecaca;\n  color: #dc2626;\n  padding: 12px;\n  border-radius: 6px;\n  margin-bottom: 20px;\n  font-size: 0.9rem;\n}\n\n/* Success Messages */\n.success-message {\n  background: #f0fdf4;\n  border: 1px solid #bbf7d0;\n  color: #16a34a;\n  padding: 12px;\n  border-radius: 6px;\n  margin-bottom: 20px;\n  font-size: 0.9rem;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .auth-box {\n    padding: 30px 24px;\n  }\n\n  .form-row {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
